import React from 'react';
import { Grid } from '@material-ui/core';

const GridContainer = (props) => {
    return (
        <Grid 
            container  
            spacing={props.spacing ? props.spacing : 3}
            direction="row"
            {...props}
        />
    )
}

const GridItem = (props) => {
    return (
        <Grid item xs={props.xs ? props.xs : 12} {...props}/>
    )
}

export { GridContainer, GridItem };